import { FiltersType, ListingRequest } from '@/api/types';
import { client } from '@/client';
import { OfficeLocation } from '@/client/accounts';
import { PartialRequestMultiselect } from '@/components/form/generic/PartialRequestMultiselect';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account';
import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

type OfficeLocationsMultiselectInputProps = {
  onChange: (value: OfficeLocation[]) => void;
  onBlur?: () => void;
  additionalFilters?: FiltersType;
  selectedOptions?: OfficeLocation[];
  isDisabled?: boolean;
  accountId?: string;
} & Omit<HTMLAttributes<HTMLSelectElement>, 'onChange' | 'defaultChecked'>;

export const OfficeLocationsMultiselectInput: React.FC<
  OfficeLocationsMultiselectInputProps
> = ({
  onChange,
  onBlur,
  className,
  additionalFilters,
  selectedOptions,
  isDisabled,
  accountId,
}) => {
  const { t } = useTranslation();
  const currentAccount = useAppSelector(selectCurrentAccount);
  const fetchOfficeLocations = isDisabled
    ? undefined
    : async (params: ListingRequest) =>
        await client.accountEntities.getOfficeLocations(
          params,
          accountId || currentAccount?.id || '',
        );

  return (
    <PartialRequestMultiselect
      dataKey="name"
      fetchService={fetchOfficeLocations}
      filter
      display="chip"
      optionLabel="name"
      optionValue="value"
      placeholder={t('generic.select')}
      maxSelectedLabels={10}
      additionalFilters={additionalFilters}
      selectedOptions={selectedOptions}
      className={className}
      handleOnChange={onChange}
      onBlur={onBlur}
      disabled={isDisabled}
      isNotListingResponse
    />
  );
};
